import React, { useEffect, useRef } from 'react';

// Сколько строк длинного списка показываем сразу и добавляем за каждую подгрузку
export const LIST_CHUNK_SIZE = 20;

// Метка в конце списка: показалась на экране — пора дорисовать следующую порцию.
// Корень наблюдения — окно браузера, а обрезку прокручиваемыми предками (тело модалки,
// .app-content) IntersectionObserver учитывает сам, поэтому метка работает в любом
// контейнере. Рендерить с key по числу показанных строк: после подгрузки метка
// пересоздается и, если все еще видна (высокий экран), сразу просит следующую порцию
const LoadMoreSentinel = ({ onVisible }) => {
  const targetRef = useRef(null);
  const onVisibleRef = useRef(onVisible);
  onVisibleRef.current = onVisible;

  useEffect(() => {
    const target = targetRef.current;
    if (!target) return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) onVisibleRef.current();
    });
    observer.observe(target);

    return () => observer.disconnect();
  }, []);

  return <div ref={targetRef} style={{ height: 1 }} aria-hidden="true" />;
};

export default LoadMoreSentinel;
